import { BuyOrderStatus, SellOrderStatus } from '@/constants/common'

// TODO: Check if this is correct
const ALL_BUY_OPEN_ORDER_STATUS = [
  BuyOrderStatus.unpaired,
  BuyOrderStatus.paired,
  BuyOrderStatus.paymentMade,
  BuyOrderStatus.complainted,
  BuyOrderStatus.canceling,
  BuyOrderStatus.appealing
]

// HACK TODO
export function getOpenBuyStatusFromFilter(filter: string): BuyOrderStatus[] {
  if (filter === 'unpaired') {
    return [BuyOrderStatus.unpaired]
  } else if (filter === 'paired') {
    return [BuyOrderStatus.paired]
  } else if (filter === 'paymentMade') {
    return [BuyOrderStatus.paymentMade]
  } else if (filter === 'complainted') {
    return [BuyOrderStatus.complainted]
  } else if (filter === 'canceling') {
    return [BuyOrderStatus.canceling]
  } else if (filter === 'appealing') {
    return [BuyOrderStatus.appealing]
  }
  return ALL_BUY_OPEN_ORDER_STATUS
}

// TODO: Check if this is correct
const ALL_BUY_ORDER_STATUS = [BuyOrderStatus.completed, BuyOrderStatus.forceCanceled, BuyOrderStatus.canceled]

// HACK TODO
export function getClosedBuyStatusFromFilter(filter: string): BuyOrderStatus[] {
  if (filter === 'completed') {
    return [BuyOrderStatus.completed]
  } else if (filter === 'canceled') {
    return [BuyOrderStatus.forceCanceled, BuyOrderStatus.canceled]
  }
  return ALL_BUY_ORDER_STATUS
}

// SELL

const ALL_SELL_OPEN_ORDER_STATUS = [
  SellOrderStatus.unpaired,
  SellOrderStatus.paired,
  SellOrderStatus.paymentMade,
  SellOrderStatus.complainted,
  SellOrderStatus.requestCancel,
  SellOrderStatus.appealing,
  SellOrderStatus.canceling
]

export function getOpenSellStatusFromFilter(filter: string): SellOrderStatus[] {
  if (filter === 'unpaired') {
    return [SellOrderStatus.unpaired]
  } else if (filter === 'paired') {
    return [SellOrderStatus.paired]
  } else if (filter === 'paymentMade') {
    return [SellOrderStatus.paymentMade]
  } else if (filter === 'complainted') {
    return [SellOrderStatus.complainted]
  } else if (filter === 'canceling') {
    return [SellOrderStatus.requestCancel, SellOrderStatus.canceling]
  } else if (filter === 'appealing') {
    return [SellOrderStatus.appealing]
  }
  return ALL_SELL_OPEN_ORDER_STATUS
}

const ALL_SELL_ORDER_STATUS = [SellOrderStatus.completed, SellOrderStatus.forceCanceled, SellOrderStatus.canceled]

export function getClosedSellStatusFromFilter(filter: string): SellOrderStatus[] {
  if (filter === 'completed') {
    return [SellOrderStatus.completed]
  } else if (filter === 'canceled') {
    return [SellOrderStatus.canceled, SellOrderStatus.forceCanceled]
  }
  return ALL_SELL_ORDER_STATUS
}
